import React from "react";
import { connect } from "react-redux";
import PT from "prop-types";

// TODO: Get sister company dynamically based on config
import "./styles.m.css";
import { NJLogo, QALogo, NHLogo } from "../logos";
import { Button } from "../../basic/button";
import get from "lodash/get";

function SisterCompaniesBase({ className = "", publisherAttributes = {} }) {
  return (
    <div className={className}>
      <div styleName="sister-companies">
        {publisherAttributes.lang !== "hi" ? (
          <a href="https://www.navjivanindia.com/" rel="noopener noreferrer" target="_blank">
            <NJLogo width={140} styleName="logo" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "ur" ? (
          <a href="https://www.qaumiawaz.com/" rel="noopener noreferrer" target="_blank">
            <QALogo width={90} styleName="logo" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "en" ? (
          <a href="https://www.nationalheraldindia.com/" rel="noopener noreferrer" target="_blank">
            <NHLogo width={140} styleName="logo" />
          </a>
        ) : null}
        {publisherAttributes.lang !== "ur" ? (
          <Button>
            <a
              href={publisherAttributes["epaper_link"] ? publisherAttributes["epaper_link"] : "javascript:void(0)"}
              rel="noopener noreferrer"
              target="_blank"
            >
              E paper
            </a>
          </Button>
        ) : null}
      </div>
    </div>
  );
}

SisterCompaniesBase.propTypes = {
  className: PT.string,
  publisherAttributes: PT.object
};

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const SisterCompanies = connect(
  mapStateToProps,
  null
)(SisterCompaniesBase);
